import { ActivityV2 } from 'models/activityV2'
import { BaseEventCard } from './BaseEventCard'

interface EmailEventCardProps {
  event: ActivityV2
  onEmailClick?: (event: ActivityV2) => void
}

export function EmailEventCard({ event, onEmailClick }: EmailEventCardProps) {
  // Get email data from field_history_objects
  const subjectField = event.field_history_objects?.find(
    (field) => field.field_name === 'subject'
  )
  const snippetField = event.field_history_objects?.find(
    (field) => field.field_name === 'snippet'
  )
  const fromField = event.field_history_objects?.find(
    (field) => field.field_name === '_from'
  )
  const toField = event.field_history_objects?.find(
    (field) => field.field_name === 'to'
  )
  const outboundField = event.field_history_objects?.find(
    (field) => field.field_name === 'outbound'
  )

  const subject = subjectField?.value || '(No subject)'
  const snippet = snippetField?.value || ''
  const fromContacts = fromField?.value || []
  const toContacts = toField?.value || []
  const isOutbound = outboundField?.value || false

  // Get sender/recipient name
  const getSenderName = () => {
    if (fromContacts.length > 0) {
      return fromContacts[0].name || fromContacts[0].email
    }
    return 'Unknown'
  }

  const getRecipientName = () => {
    if (toContacts.length > 0) {
      return toContacts[0].name || toContacts[0].email
    }
    return 'Unknown'
  }

  // Build action text
  const actionText = isOutbound
    ? `sent an email to ${getRecipientName()}`
    : `sent you an email`

  return (
    <BaseEventCard event={event}>
      <div
        className="space-y-1 cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => onEmailClick?.(event)}
      >
        {/* User name and action */}
        <div className="font-inter text-sm leading-[1.43] text-fg-secondary">
          <span className="text-fb-dark-green font-bold">
            {isOutbound ? event.user_name : getSenderName()}
          </span>{' '}
          {actionText}
        </div>

        {/* Email subject */}
        <div className="font-inter text-sm leading-[1.43] font-medium text-fb-dark-green">
          {subject}
        </div>

        {/* Email snippet */}
        {snippet && (
          <div className="font-inter text-sm leading-[1.43] text-fg-secondary line-clamp-2">
            {snippet}
          </div>
        )}
      </div>
    </BaseEventCard>
  )
}
